<template>
  <span>
    <v-badge :color="getColor()" :content="getText()"> </v-badge>
  </span>
</template>

<script>
import tipos from '../models/tipo-historico-aluno';

export default {
  props: {
    value: Number,
  },

  data() {
    return {
      valueItem: this.value,
    };
  },
  computed: {},

  watch: {
    value(newVal) {
      this.valueItem = newVal || ''; // Atualiza a internalDate quando um novo formulário é carregado
    },
  },

  methods: {
    getColor() {
      return tipos[this.valueItem - 1].color;
    },
    getText() {
      return tipos[this.valueItem - 1].text;
    },
  },
};
</script>
